<!-- MasterBookのタイトル表示 -->
<template>
  <h1 class="ticket-name">{{ name }}</h1>
</template>

<script>
export default {
  name: "MbNameDisp",
  props: {
    name: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.ticket-name {
  margin: 15px 0 22px 0 !important;
  font-size: 18px;
  font-weight: bold;
}
</style>
